import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const item_id = document.getElementById("comment-box-new").getAttribute("item_id");
const item_type = document.getElementById("comment-box-new").getAttribute("item_type");
const item_action = document.getElementById("comment-box-new").getAttribute("item_action");
const avatar = document.getElementById("comment-box-new").getAttribute("avatar");
const username = document.getElementById("comment-box-new").getAttribute("username");
const user_id = document.getElementById("comment-box-new").getAttribute("user_id");
const is_mod_hoidap = document.getElementById("comment-box-new").getAttribute("is_mod_hoidap");
const is_bought_course = document.getElementById("comment-box-new").getAttribute("is_bought_course");
const is_bought_topic = document.getElementById("comment-box-new").getAttribute("is_bought_topic");
const is_bought_lesson = document.getElementById("comment-box-new").getAttribute("is_bought_lesson");

ReactDOM.render(

  <React.StrictMode>
    <App is_bought_course={is_bought_course} is_bought_topic={is_bought_topic} is_bought_lesson={is_bought_lesson} item_id={item_id} item_type={item_type} avatar={avatar} username={username} user_id={user_id} is_mod_hoidap={is_mod_hoidap} item_action={item_action} />
  </React.StrictMode>,
  document.getElementById('comment-box-new')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
